import { useRecoilState, useRecoilValue } from "recoil";
import {
  aptInfoDataList,
  modalState,
  selectLive,
  selectSize,
  selectTab,
} from "../atoms";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Modal = () => {
  const [data, setData] = useState([]);
  const [windowWidth, setWindowWidth] = useState();
  const [state, setState] = useRecoilState(modalState);
  const [size, setSize] = useRecoilState(selectSize);
  const [date, setDate] = useRecoilState(selectTab);
  const [live, setLive] = useRecoilState(selectLive);
  const aptSizeDataList = useRecoilValue(aptInfoDataList);

  const handleModal = () => {
    setState((prev) => {
      return {
        ...prev,
        state: false,
      };
    });
    document.body.style.overflow = "unset";
  };

  const handleClick = (e, data) => {
    const type = state.type;
    switch (type) {
      case "date": {
        return setDate(data);
      }

      case "size": {
        if (e.target.dataset.name) {
          return setSize(e.target.dataset.name);
        } else {
          return setSize(e.target.parentNode.dataset.name);
        }
      }

      default: {
        return setLive(data);
      }
    }
  };

  useEffect(() => {
    const type = state.type;
    switch (type) {
      case "date": {
        return setData([
          { title: "최근 3년", type: "recent" },
          { title: "전체기간", type: "all" },
        ]);
      }

      case "size": {
        return setData(aptSizeDataList);
      }

      default: {
        return setData([
          { title: "매매", type: "m" },
          { title: "전/월세", type: "jw" },
        ]);
      }
    }
  }, [state]);

  useEffect(() => {
    if (state.state) {
      document.body.style.overflow = "hidden";
    }
  }, [state]);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  return (
    <ModalComponent className="fixed-bottom" onClick={handleModal}>
      <ModalInfoComponent className="w-100 d-flex flex-column fixed-bottom bg-white">
        <ModalInfoTitleComponent className="d-flex flex-row justify-content-end align-items-center py-3 bg-white">
          <ModalInfoTitle className="position-absolute font-weight-bold">
            평형
          </ModalInfoTitle>
          <ModalInfoCloseButton className="pr-3">
            <ModalIcon className="i-close" />
          </ModalInfoCloseButton>
        </ModalInfoTitleComponent>
        <ModalInfoList className="w-100 p-0">
          {state.type === "size"
            ? data.map((data) => {
                return (
                  <ModalInfoListItem
                    key={data.j_area}
                    className="d-block border-top border-gray-200"
                  >
                    <ModalInfoListItemTextContainer
                      className="w-100 d-flex flex-row justify-content-between align-items-center"
                      onClick={(e) => handleClick(e, "")}
                      style={{ color: data.j_area === size && "black" }}
                      data-name={data.j_area}
                    >
                      <ModalInfoListItemText>
                        {data.pyeong}평
                      </ModalInfoListItemText>
                      <ModalInfoListItemText>
                        {data.household}세대
                      </ModalInfoListItemText>
                      {windowWidth <= 320 ? (
                        <ModalInfoListItemText>
                          공급 {data.g_area}㎡ {"\n"} 전용 {data.j_area}㎡
                        </ModalInfoListItemText>
                      ) : (
                        <>
                          <ModalInfoListItemText>
                            공급 {data.g_area}㎡
                          </ModalInfoListItemText>
                          <ModalInfoListItemText>
                            전용 {data.j_area}㎡
                          </ModalInfoListItemText>
                        </>
                      )}
                    </ModalInfoListItemTextContainer>
                  </ModalInfoListItem>
                );
              })
            : data.map((data) => {
                return (
                  <ModalInfoListItem
                    key={data.title}
                    className="d-block border-top border-gray-200"
                  >
                    <ModalInfoListItemTextContainer
                      className="w-100 d-flex flex-row align-items-center"
                      onClick={(e) => handleClick(e, data.type)}
                      style={{
                        color:
                          (data.type === date && "black") ||
                          (data.type === live && "black"),
                      }}
                    >
                      <ModalInfoListItemText>
                        {data.title}
                      </ModalInfoListItemText>
                    </ModalInfoListItemTextContainer>
                  </ModalInfoListItem>
                );
              })}
        </ModalInfoList>
      </ModalInfoComponent>
    </ModalComponent>
  );
};

const ModalComponent = styled.section`
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1004;
`;

const ModalInfoComponent = styled.section`
  min-height: 30%;
  max-height: 50%;
  border-radius: 0.3rem 0.3rem 0 0;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

const ModalInfoTitleComponent = styled.div`
  border-radius: 30px 30px 0 0;
  z-index: 2;
`;
const ModalInfoTitle = styled.h3`
  right: 45%;
`;
const ModalInfoCloseButton = styled.div`
  cursor: pointer;
`;
const ModalInfoList = styled.ul`
  min-height: 20%;
`;
const ModalInfoListItem = styled.li``;
const ModalInfoListItemTextContainer = styled.div`
  padding: 1.2rem;
  color: #aaaaaa;
  @media screen and (max-width: 320px) {
    padding: 0.8rem 0 0.8rem 1.2rem;
  }
`;
const ModalInfoListItemText = styled.h5`
  display: block;

  white-space: pre-line;
`;

const ModalIcon = styled.i``;

export default Modal;
